// extracted by mini-css-extract-plugin
module.exports = {"table":"StringTimeSelector_table___8nJG","dropdownArrow":"StringTimeSelector_dropdownArrow__3cE1N"};